import { InterfaceFeature } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllInterfaceFeatures = () => getAllEnumOptions(InterfaceFeature)

export const getInterfaceFeatureLabel = (key?: InterfaceFeature) => {
  if (key === null || typeof key === 'undefined') return ''

  return InterfaceFeature[key]
}
